import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useContext } from "react";
import { useIntl } from "react-intl";
import List from "@mui/material/List";
import ListItemSidebar from "../../../../../common/components/listitem/ListItemSidebar";
import { StoreContext } from "../../../../../store/StoreProvider";
// eslint-disable-next-line import/no-cycle
import { subConfig } from "../../SnaWAConfig";
import Act from "../../../../../store/actions";
import WarningOnExit from "./component/WarningOnExit";

const DigitalAITool = () => {
  const intl = useIntl();
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { subPage } = sna;

  return (
    <Box>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="body1"
          sx={{
            color: "#fff",
          }}
        >
          {intl.formatMessage({
            id: "sna.sidebar.digitalAI.title",
            defaultMessage: "數位小助理",
          })}
        </Typography>
      </Box>
      <List>
        {subConfig.digitalAI.content.map((item, idx) => (
          <ListItemSidebar
            key={idx.toString()}
            textPrimary={<Typography variant="body2">{item.label}</Typography>}
            listItemProps={{
              onClick: () => {
                dispatch({
                  type: Act.SNA_SET_SUBPAGE,
                  payload: item.name,
                });
              },
            }}
            listItemButtonProps={{ selected: item.name === subPage }}
          />
        ))}
      </List>
      <WarningOnExit />
    </Box>
  );
};

export default DigitalAITool;
